import {
  Box,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Typography,
  ListItemIcon,
} from "@mui/material";
import React, { useCallback, useState } from "react";
import { transitionStatus } from "../redux/features/settingsSlice";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";

export default function TransitionSettings() {
  const data = useSelector((state) => state.settings.transitionStatus);
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleTransitionChange = useCallback(
    (transition, otherProps = "") => {
      dispatch(transitionStatus({ transition, otherProps }));
    },
    [dispatch]
  );

  return (
    <div>
      <Box padding={2}>
        <Typography variant="subtitle2" sx={{ color: "#9aa6b2" }}>
          Transitions
        </Typography>
      </Box>
      <Box width={"100%"} padding={1}>
        <Stack direction={"row"} spacing={2}>
          {["Fade", "Collapse", "Grow", "Zoom"].map((transition) => (
            <Box key={transition} width={"50%"}>
              <Paper
                elevation={3}
                sx={{
                  backgroundColor:
                    data.transition === transition ? "#d6c3eb" : "white",
                  width: "100%",
                  height: 50,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  "&:hover": { boxShadow: " -1px 5px 5px 0px rgba(0,0,0,0.4)" },
                }}
                onClick={() => handleTransitionChange(transition)}
              >
                {data.transition === transition && (
                  <Box paddingTop={1}>
                    <Icon
                      icon="line-md:confirm-circle"
                      width="22"
                      height="22"
                    />
                  </Box>
                )}
                <Typography fontWeight={"bolder"} variant="subtitle2">
                  {transition}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Stack>

        <Box marginTop={2}>
          <Paper
            elevation={3}
            sx={{
              backgroundColor:
                data.transition === "Slide" ? "#d6c3eb" : "white",
              width: "100%",
              height: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              "&:hover": { boxShadow: " -1px 5px 5px 0px rgba(0,0,0,0.4)" },
            }}
            onClick={handleClick}
          >
            {data.transition === "Slide" && (
              <Box paddingTop={1}>
                <Icon icon="line-md:confirm-circle" width="22" height="22" />
              </Box>
            )}
            <Typography variant="subtitle2">Slide</Typography>
          </Paper>
        </Box>
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
      >
        {["up", "down", "left", "right"].map((direction) => (
          <MenuItem
            key={direction}
            onClick={() => {
              handleTransitionChange("Slide", direction);
              handleClose();
            }}
          >
            <ListItemIcon>
              <Icon
                icon={`line-md:chevron-small-double-${direction}`}
                width="22"
                height="22"
              />
            </ListItemIcon>
            {direction.charAt(0).toUpperCase() + direction.slice(1)}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
